import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
export function PartnerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white font-sans selection:bg-violet-electric/30 pt-32 pb-20" data-id="element-394">
      <section id="hero" className="max-w-4xl mx-auto px-6 text-center" data-id="element-395">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-violet-electric text-sm font-semibold tracking-widest uppercase mb-6 block" data-id="element-396">

          Partnerships
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8" data-id="element-397">

          Partner with Thruline
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="prose prose-invert prose-lg mx-auto mb-12" data-id="element-398">

          <p className="text-xl text-white/60 leading-relaxed" data-id="element-399">
            We work with industry consultants, system integrators, and
            technology providers to deliver comprehensive solutions to
            manufacturers. As a Thruline partner, you'll get access to our
            platform, training resources, and dedicated support to help your
            clients succeed.
          </p>
          <p className="text-xl text-white/60 leading-relaxed mt-6" data-id="element-400">
            Whether you're looking to implement Thruline for your clients or
            integrate your technology with our platform, we'd love to explore
            how we can work together.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="inline-block" data-id="element-401">

          <a href="mailto:partners@thruline.ai" className="flex items-center gap-3 px-8 py-4 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-violet-electric/50 transition-all group" data-id="element-402">

            <div className="w-10 h-10 rounded-full bg-violet-electric/20 flex items-center justify-center group-hover:bg-violet-electric/30 transition-colors" data-id="element-403">
              <MailIcon className="w-5 h-5 text-violet-electric" data-id="element-404" />
            </div>
            <div className="text-left" data-id="element-405">
              <span className="block text-xs text-white/40 uppercase tracking-wider font-semibold" data-id="element-406">
                Get in touch
              </span>
              <span className="block text-lg font-medium text-white" data-id="element-407">
                partners@thruline.ai
              </span>
            </div>
          </a>
        </motion.div>
      </section>
    </div>;
}